"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayImage = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.OverlayImage = styled_components_1.default.img `
	position: absolute;

	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
`;
